class IntersectionObserver {
  constructor() {
    this.observer = new window.IntersectionObserver(
      this.handleIntersect.bind(this),
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // console.log("Element in view: ", entry.target);

        setTimeout(() => {
          entry.target.classList.add("animate"); // Add the 'animate' class when in view
        }, 500); 

      } else {
        // console.log("Element out of view: ", entry.target);
        // entry.target.classList.remove("animate"); // Remove the 'animate' class when out of view
      }
    });
  }

  observe(element) {
    this.observer.observe(element);
  }
}

// export as a singleton
export default new IntersectionObserver();
